import {
  Input, Component, ContentChild, TemplateRef
} from '@angular/core';

@Component({
  selector: 'sm-dt-summary',
  template: '<!-- summary row -->',
  standalone: false
})
export class SummaryComponent {
  constructor() {}

  @ContentChild('value')
    valueTemplate: TemplateRef<any>;

  @Input()
    label: string;

  @Input()
    value: string;

  @Input()
    secondary = false;
}
